import React from 'react';

export default ({ record }) => {
  return (
    <span>
      User
      {record ? `: ${record.name}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Role/Title.js